import {useState, useEffect, useMemo} from 'react';
import {Checkbox} from '../reusableElementsComponents/Checkbox';
import B2BApiService from "../../B2bApiService";
import ExplanationTooltip from "./ExplanationTooltip";
// import {useSelector} from "react-redux";
import { lookups } from '../../content';


function Assessments({data, updateData, dataEditedFlag, setDataEditedFlag}) {
    // const contentfulData = useSelector(state => state.contentfulData.all['General definations']?.fields);
    const [updateAssessments, setUpdateAssessments] = useState([]);
    const [assessments, setAssessments] = useState( []);
    const invalidInstruments = [111,357,315];

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    },[]);

    useEffect(() => {
        if (!assessments.length) {
            b2bServiceObj.LoadAssessments(setAssessments);
        }
        if (data.assessments && assessments.length) {
            let newAssessment = [...assessments];
            newAssessment.map((val) => {
                val['isChecked'] = data.assessments.includes(val.id);
                return val;
            });
            setUpdateAssessments([...newAssessment]);
        }
        else {
            setUpdateAssessments([...assessments]);
        }
    }, [b2bServiceObj, assessments, data]);

    function handleChange(e, value) {
        if (e.target.checked) {
            if (updateData) {
                updateData([...data?.assessments, value.id]);
            } else {
                data.assessments.push(value.id);
                value.isChecked = true;
                setUpdateAssessments([...updateAssessments]);
            }
        } else {
            if (updateData) {
                updateData(data?.assessments?.filter(id => id !== value.id));
            } else {
                data.assessments.splice(data.assessments.indexOf(value), 1)
                value.isChecked = false;
                setUpdateAssessments([...updateAssessments]);
            }
        }
        setDataEditedFlag && setDataEditedFlag(true);
    }

    return (
        <div className='assessments-wrapper section'>
        <div className='assessment-card-wrapper'>
            {updateAssessments &&
            updateAssessments.map((assessment, index) => {
                if (!invalidInstruments.includes(assessment.instrument)) {
                    return (
                        !assessment['is-custom-test'] && assessment['instrument'] !== 111 &&
                        <div key={index} className='assessment-card'>
                            <Checkbox isChecked={assessment.isChecked} onChange={(e) => { handleChange(e, assessment) }} />
                            <p className='m m-10 left'>
                                {assessment.instrument === 102 && lookups.assessments['102']?.name}
                                {assessment.instrument === 201 && lookups.assessments['201']?.name}
                                {assessment.instrument === 302 && lookups.assessments['302']?.name}
                                {assessment.instrument === 301 && lookups.assessments['301']?.name}
                                {assessment.instrument === 344 && lookups.assessments['344']?.name}
                                {assessment.instrument === 370 && lookups.assessments['370']?.name}
                                {assessment.instrument === 390 && lookups.assessments['390']?.name}
                                {assessment.instrument === 315 && assessment.name}
                                <ExplanationTooltip>
                                    <p>
                                        {assessment.instrument === 102 && lookups.assessments['102']?.tooltip}
                                        {assessment.instrument === 201 && lookups.assessments['201']?.tooltip}
                                        {assessment.instrument === 302 && lookups.assessments['302']?.tooltip}
                                        {assessment.instrument === 301 && lookups.assessments['301']?.tooltip}
                                        {assessment.instrument === 344 && lookups.assessments['344']?.tooltip}
                                        {assessment.instrument === 370 && lookups.assessments['370']?.tooltip}
                                        {assessment.instrument === 390 && lookups.assessments['390']?.tooltip}
                                        {assessment.instrument === 315 && assessment.name}
                                    </p>
                                </ExplanationTooltip>
                            </p>
                        </div>
                    )
                } else {
                    return ""
                }
            })
            }
        </div>
        {dataEditedFlag && <div className="unsaved-changes">unsaved changes <span className="cta-txt">(Click Save Button)</span></div>}
        </div>
    )
}

export default Assessments
